module.exports = __webpack_public_path__ + "static/media/card-1.3b717e86.svg";